export default __webpack_public_path__ + "static/media/num-one.b30bea8a.svg";